import React from 'react';
import { Expense } from '../../types';
import {
  getReviewStatusDotState,
  getReviewStatusDotTitle,
  ReviewStatusDotState,
} from '../../utils/reviewStatusDot';
import styles from './ExpenseReviewStatusDot.module.css';

type ExpenseReviewStatusDotProps = {
  expense: Expense;
  reviewed: boolean;
  variant: 'table' | 'editor';
  className?: string;
};

const STATE_CLASS: Record<Exclude<ReviewStatusDotState, 'none'>, string> = {
  red: styles.statusDotRed,
  green: styles.statusDotGreen,
  pink: styles.statusDotPink,
  grey: styles.statusDotGrey,
};

export const ExpenseReviewStatusDot: React.FC<ExpenseReviewStatusDotProps> = ({
  expense,
  reviewed,
  className,
}) => {
  const state = getReviewStatusDotState(expense, reviewed);
  if (state === 'none') return null;

  const title = getReviewStatusDotTitle(state, expense);

  return (
    <span
      className={`${styles.statusDot} ${STATE_CLASS[state]} ${className ?? ''}`.trim()}
      title={title}
      aria-label={title}
    />
  );
};
